import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import AppInput from '../../../../common/AppInput';
import ProductPreview from '../../../../common/ProductPreview';
import Message from '../../../../common/Message';
import Loader from '../../../../common/Loader';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import { COMPLETE_FORM, CHANGE_ADDRESS } from '../../../../../constants/texts';
import { useChageAddressStyles } from './styles';
import { textMapper } from '../../../../../helpers/FormHelper';

const Form = ({ ...props }) => {
  const { state, onData, fields, mobile, motiveId, setShowForm } = props;
  const classes = useChageAddressStyles({ mobile });
  const { messages, status, getStatus } = useSelector(
    (state) => state.validationProductSlice,
  );
  const showMessage = messages.length > 0;
  const loadingGif = getStatus === 'loading';

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    setShowForm(status);
  }, [status]);

  useEffect(() => {
    if (loadingGif) setShowForm(false);
    else setShowForm(status);
  }, [loadingGif]);

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      {loadingGif && <Loader mobile={mobile} />}

      {!loadingGif && (
        <React.Fragment>
          <ProductPreview mobile={mobile} />

          <Message
            message={!showMessage ? CHANGE_ADDRESS : messages}
            severity="info"
            fullRounded
          />

          {status && (
            <React.Fragment>
              <Typography className={classes.title}>{COMPLETE_FORM}</Typography>
              {fields.map((field, index) => (
                <React.Fragment key={index}>
                  {!field.hidden && (
                    <AppInput
                      onChange={handleChange}
                      onBlur={() => {}}
                      onClick={() => {}}
                      disabled={state[field.name]?.disabled || false}
                      name={field.name}
                      error={state[field.name]?.error || false}
                      type={state[field.name]?.type || ''}
                      label={state[field.name]?.label || ''}
                      required={state[field.name]?.required || false}
                      inputAdornment={state[field.name]?.inputAdornment || ''}
                      success={state[field.name]?.success || ''}
                      helperText={state[field.name]?.helper || ''}
                      multiline={state[field.name]?.multiline || false}
                      rows={state[field.name]?.rows || ''}
                      value={state[field.name]?.value || ''}
                      errorMessage={state[field.name]?.message || ''}
                    />
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  setShowForm: PropTypes.bool,
};

export default Form;
